import _ from 'lodash';

import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared/notify';
import fetch from '../../fetch';
import reducers from './reducers';
import { fetchBlob } from '../../fetchBlob';
import moment from 'moment';

const store = (() => {
    const get = (id, resultType) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/LojaConcessionaria/StoresInfo`,
            async: false,
            data: {
                Id: id,
                templateResultType: resultType
            }
        }).then(reducers.store, notifyError);
    };

    get.unapprovedStores = (id) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/LojaConcessionaria/getstoreinfounapproved`,
            async: false,
            data: {
                Id: id,
            }
        }).then(reducers.storeUnapproved, notifyError);
    };

    get.storeplannedinfo = (id) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/LojaConcessionaria/getstoreinfoplanned`,
            async: false,
            data: {
                Id: id,
            }
        }).then(reducers.storePlanned, notifyError);
    };

    get.unapprovedStores.export = ({bbox}) => {
        return fetchBlob({
        fileName: `Neocom_Lojas Nao Homologadas Selecionadas_v${moment().format('YYYYMMDD')}.xlsx`,
        url: `${environment.get('API_HOST')}/LojaConcessionaria/spreadsheet/generateStoreUnapproved`,
        type: 'POST',
        parameters: {
            bbox: bbox
        }
      });
    };

    get.protectArea = (storeId, bbox) => {
        const storeQuery = storeId
            ? `&storeId=${storeId}`
            : '';

        const bboxData = typeof (bbox) === 'undefined' || bbox === 'null' ? '' : bbox;

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/protectareas?bbox=${bboxData}${storeQuery}`,
            noLoading: true
        }).then(reducers.protectArea);
    };
    
    get.retention = {
        period: () => {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/lojaconcessionaria/GetRetentionDateFilter`,
                async: false
            }).then(reducers.retention.period, notifyError);
        }
    };

    get.directSales = {
        period: () => {
            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/lojaconcessionaria/GetDirectSalesDateFilter`,
                async: false
            }).then(reducers.directSales.period, notifyError);
        }
    };

    get.sales = data => {
        const _success = function (res) {
            if (!res) {
                const message = { type: NOTIFY_TYPE.ALERT, text: 'Não foi possível recuperar as médias mensais' };
                notifyError(null, message);
            }

            return res;
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/LojaConcessionaria/ObterMediaMensal`,
            data: JSON.stringify(data),
            error: notifyError
        }).then(_success, () => null);
    };

    get.sales.download = data => {
      return fetchBlob({
        fileName: `Neocom_Lojas Selecionadas_v${moment().format('YYYYMMDD')}.xlsx`,
        url: `${environment.get('API_HOST')}/LojaConcessionaria/spreadsheet/generateStoreSales`,
        type: 'POST',
        parameters: data
      });
    };

    get.sales.history = id => {
        const _error = err => {
            console.log(`ERROR: ${err}`);
            return null;
        };

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/loja/obtervendasgrafico/`,
            header: {
                'X-UIKey': 'stores-sales-history-view'
            },
            data: {
                id
            }
        }).then(reducers.sales.history, _error);
    };

    get.sales.bySegment = id => {
        const _error = err => {
            console.log(`ERROR: ${err}`);
            return null;
        };

        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/loja/GetStoreSalesBySegments/`,
            data: {
                idStore: id
            }
        }).then(reducers.sales.bySegment, _error);
    };

    get.serviceArea = (lat, lng, breaks, type = 3) =>
        fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/loja/CalcularServiceArea`,
            header: {
                'X-UIKey': 'stores-service-area-generate'
            },
            data: {
                lat,
                lng,
                breaks,
                type
            }
        });

    get.protectedArea = (lat, lng) =>
        fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/loja/ChecarProtectedArea`,
            header: {
                'X-UIKey': 'points-create'
            },
            async: false,
            data: {
                lat,
                lng
            }
        });

    get.all = (brands, type) =>
        fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/GetStoreDealers`,
            data: JSON.stringify({
                Bandeira: _.isArray(brands) ? brands.join(',') : brands,
                Tipo: _.isArray(type) ? type.join(',') : type
            })
        }).then(reducers.featuresProperties, notifyError);

    get.all.dealerships = (brands, type) =>
        fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/GetStoreDealers`,
            data: JSON.stringify({
                Bandeira: _.isArray(brands) ? brands.join(',') : brands,
                Tipo: _.isArray(type) ? type.join(',') : type
            })
        });

    get.all.competitors = (brands, consultType) =>
        fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/GetStoreCompetitors`,
            data: JSON.stringify({
                Bandeira: _.isArray(brands) ? brands.join(',') : brands,
                ConsultType: consultType
            })
        });

    get.customers = (id, startDate, endDate) =>
        fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/getClients?IdLoja=${id}&AnoMesInicio=${startDate}&AnoMesFim=${endDate}`
        }).then(reducers.featuresProperties, notifyError);

    get.customers.fromBbox = (bbox, startDate, endDate) =>
        fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/lojaconcessionaria/getClientsFromBbox?Bbox=${bbox}&AnoMesInicio=${startDate}&AnoMesFim=${endDate}`
        });

    const add = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Loja criada com sucesso.' };
            notifySuccess(message);
        };

        if (!_.isObject(req.Bandeiras)) {
            req.Bandeiras = [req.Bandeiras];
        }

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/loja/inserirloja`,
            data: JSON.stringify(req)
        }).then(_success, notifyError);
    };

    const update = req => {
        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Loja atualizada com sucesso.' };
            notifySuccess(message);
        };

        if (!_.isObject(req.Bandeiras)) {
            req.Bandeiras = [req.Bandeiras];
        }

        return fetch({
            type: 'PUT',
            url: `${environment.get('API_HOST')}/loja/atualizarloja`,
            data: JSON.stringify(req)
        }).then(_success, notifyError);
    };

    update.serviceArea = (req, callback) => {
        const _error = error => {
            const message = { type: NOTIFY_TYPE.ERROR, text: 'Erro ao salvar área' };
            notifyError(error, message);
            if (callback) {
                return callback();
            }
        };

        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área da loja criada com sucesso.' };
            notifySuccess(message);
            if (callback) {
                return callback();
            }
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/loja/atualizarservicearea`,
            header: {
                'X-UIKey': 'stores-service-area-regenerate'
            },
            data: JSON.stringify(req),
            success: (req.success || null)
        }).then(_success, _error);
    };

	const del = {};

	del.serviceArea = (req, callback) => {
        const _error = error => {
            const message = { type: NOTIFY_TYPE.ERROR, text: 'Erro ao excluir área' };
            notifyError(error, message);
            if (callback) {
                return callback();
            }
        };

        const _success = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Área excluída com sucesso.' };
            notifySuccess(message);
            if (callback) {
                return callback();
            }
        };

        return fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/loja/excluirservicearea`,
            header: {
                'X-UIKey': 'stores-service-area-regenerate'
            },
            data: JSON.stringify(req),
            success: (req.success || null)
        }).then(_success, _error);
	};
    
    const post = {
        export: ({ bbox, exportType, fileName }) => {
            return fetchBlob({
                fileName: fileName,
                url: `${environment.get('API_HOST')}/lojaconcessionaria/export`,
                type: 'POST',
                parameters: {
                    bbox,
                    exportType
                }
            });
        }
    };

    return {
        add,
        post,
        get,
        update,
		del
    };
})();

export default store;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/store/index.js